import styled from 'styled-components';
import { theme } from '@spa/shared/theme';
import Separator from '@spa/shared/components/Unisystem/Separator';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-zh2eq-0"
})(["display:flex;flex-direction:column;gap:", ";", "{border-top:1px solid ", ";}"], function (props) {
  return props.theme.space(5);
}, Separator, theme.separator.color);
export var Title = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-zh2eq-1"
})(["font-size:", ";color:", ";margin-top:-", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.colors.cornFlowerBlue;
}, function (props) {
  return props.theme.space(4);
});